module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "order-create"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "order-create-main"
  }, [_vm._m(3), _vm._v(" "), _c('p', [_c('span', [_vm._v("Order ID：" + _vm._s(_vm.$route.query.orderId))]), _vm._v(" "), _c('span', [_vm._v("Order total：" + _vm._s(_vm._f("currency")(_vm.orderTotal, '$')))])]), _vm._v(" "), _c('div', {
    staticClass: "order-create-btn-wrap"
  }, [_c('div', {
    staticClass: "btn-l-wrap"
  }, [_c('router-link', {
    staticClass: "btn btn--m",
    attrs: {
      "href": "javascript:;",
      "to": "/cart"
    }
  }, [_vm._v("Cart List")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-r-wrap"
  }, [_c('router-link', {
    staticClass: "btn btn--m",
    attrs: {
      "href": "javascript:;",
      "to": "/"
    }
  }, [_vm._v("Goods List")])], 1)])])])]), _vm._v(" "), _c('nav-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-normal"
  }, [_c('h2', {
    staticClass: "page-title-h2"
  }, [_c('span', [_vm._v("check out")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check-step"
  }, [_c('ul', [_c('li', {
    staticClass: "cur"
  }, [_c('span', [_vm._v("Confirm")]), _vm._v(" address")]), _vm._v(" "), _c('li', {
    staticClass: "cur"
  }, [_c('span', [_vm._v("View your")]), _vm._v(" order")]), _vm._v(" "), _c('li', {
    staticClass: "cur"
  }, [_c('span', [_vm._v("Make")]), _vm._v(" payment")]), _vm._v(" "), _c('li', {
    staticClass: "cur"
  }, [_c('span', [_vm._v("Order")]), _vm._v(" confirmation")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-create-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/ok-2.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Congratulations! "), _c('br'), _vm._v("Your order is under processing!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5883aa78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/orderSuc.vue
// module id = 80
// module chunks = 0